import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "history-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-long-arrow-left mr-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Tất cả giai đoạn ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_HistoryItem = _resolveComponent("HistoryItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          loading: _ctx.loading
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.logs.length)
      ? (_openBlock(), _createBlock(_component_Empty, {
          key: 1,
          message: "Không có lịch sử!"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        class: "back-link pl-3 mt-2"
      }, _hoisted_4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (item, index) => {
        return (_openBlock(), _createBlock(_component_HistoryItem, {
          history: item,
          key: index
        }, null, 8, ["history"]))
      }), 128))
    ])
  ], 64))
}